/**
 * Q8 boundaries.0 (CLAUDE.md section 4, "contradiction holds"; F-08; TA-119).
 *
 * A KB chunk flagged `needsReview` is a fact two sources disagree on, held
 * entirely until a human settles it. No agent may answer from one, and no eval
 * may reward a reply that quotes one. This is the one pure filter every
 * in-process consumer of a KB applies, so the rule has a single definition:
 * the `ReplyAgent` constructor (retrieval and verification) and the pipeline
 * (`runPipelineAt`, `syntheticAt`). The eval runner does not call it: it hands
 * the whole KB to a `ReplyAgent`, and the constructor drops the held chunks
 * itself (fix C5). Generic over the chunk type so core needs no pipeline import.
 *
 * The held ids come back so the caller can say so out loud (section 0).
 */
export interface MaybeHeldChunk {
  readonly id: string;
  readonly needsReview?: boolean;
}

export function withholdHeldChunks<C extends MaybeHeldChunk>(
  chunks: readonly C[],
): { readonly served: readonly C[]; readonly held: readonly string[] } {
  const served: C[] = [];
  const held: string[] = [];
  for (const c of chunks) {
    if (c.needsReview === true) held.push(c.id);
    else served.push(c);
  }
  return { served, held };
}
